<template>
  <article :class="{ 'container-fluid': !isMobile, 'mx-n3': isMobile }">
    <div class="row">
      <div class="col">
        <SectionTitle
          title="Información del Asistente"
          icon="fas fa-file-user"
          reverse
        />
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-4 mb-4">
        <ValidationProvider v-slot="{ errors }" rules="required">
          <CustomInput
            v-model="model.name"
            :error="errors[0]"
            :disabled="disabled"
            custom-error-msg="El nombre es requerido."
            label="Nombre:"
            class="px-3"
          />
        </ValidationProvider>
      </div>
      <div class="col-12 col-md-4 mb-4">
        <ValidationProvider v-slot="{ errors }" rules="required">
          <CustomInput
            v-model="model.paternalSurname"
            :error="errors[0]"
            :disabled="disabled"
            custom-error-msg="El apellido paterno es requerido."
            label="Apellido Paterno:"
            class="px-3"
          />
        </ValidationProvider>
      </div>
      <div class="col-12 col-md-4 mb-4">
        <ValidationProvider v-slot="{ errors }" rules="required">
          <CustomInput
            v-model="model.maternalSurname"
            :error="errors[0]"
            :disabled="disabled"
            custom-error-msg="El apellido materno es requerido."
            label="Apellido Materno:"
            class="px-3"
          />
        </ValidationProvider>
      </div>
      <div class="col-12 col-md-4 mb-4">
        <ValidationProvider v-slot="{ errors }" rules="required">
          <CustomInput
            v-model="model.contactPhone"
            :error="errors[0]"
            :disabled="disabled"
            custom-error-msg="El teléfono es requerido."
            label="Teléfono:"
            mask-type="Phone"
            class="px-3"
            placeholder="(__) __-____"
          />
        </ValidationProvider>
      </div>
      <div class="col-12 col-md-4 mb-4">
        <ValidationProvider v-slot="{ errors }" rules="required">
          <CustomInput
            v-model="model.email"
            :error="errors[0]"
            :disabled="disabled"
            custom-error-msg="El correo electrónico es requerido."
            label="Correo Electrónico:"
            class="px-3"
            type="email"
          />
        </ValidationProvider>
      </div>
    </div>
  </article>
</template>

<script>
import SectionTitle from 'SectionTitle';
import CustomInput from 'CustomInput';
import alert from '@/mixin/alert.mixin';

export default {
  name: 'AssistantInformation',
  mixins: [alert],
  components: {
    SectionTitle,
    CustomInput,
  },
  data() {
    return {};
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    model() {
      return this.value;
    },
    isMobile() {
      return this.$store.getters.getIsMobileDensity;
    },
  },
  methods: {},
  mounted() {},
};
</script>

<style lang="scss" scoped>
::v-deep .student-search-alert-error {
  height: 0;
}
</style>
